import { render, staticRenderFns } from "./WelcomeToPatientLetter.vue?vue&type=template&id=15cf34e5&"
import script from "./WelcomeToPatientLetter.vue?vue&type=script&lang=ts&"
export * from "./WelcomeToPatientLetter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports